<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputToggle" });
import "tailwindcss/tailwind.css";
import { onMount } from "svelte";
import { v4 as uuid } from "uuid";
export let name;
export let label = "";
export let isChecked = false;
export let isDisabled = false;
export let isRequired = false;
export let css = "";
export let size = "md";
export let align = "left";
export let color = "dark";
let id = "";
let isError = false;
const validate = (event) => {
    if (event.target === null) {
        return;
    }
    isError = !event.target.validity.valid;
};
const onChange = (event) => {
    const TARGET = event.target;
    isChecked = TARGET.checked;
    validate(event);
};
onMount(() => {
    id = uuid();
});
</script>

<input
    type = 'checkbox'
    checked = { isChecked }
    disabled = { isDisabled }
    required = { isRequired }
    value = { true }
    { id }
    { name }
    on:invalid = { validate }
    on:change = { onChange }
    on:change
/>

<label for = { id } class = { `s8-input-toggle ${ css } s8-${ size } s8-${ align } s8-${ color }`}>
    <slot { isChecked } { isDisabled } { isError }>{ label }</slot>
</label>

<style>

    label.s8-input-toggle {
            position: relative;
            display: inline-block;
            cursor: pointer;
            -webkit-user-select: none;
               -moz-user-select: none;
                    user-select: none;
            line-height: 1.25
}

        label.s8-input-toggle:after,
        label.s8-input-toggle:before {
            position: absolute;
            top: 50%;
            --tw-translate-y: -50%;
            transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
            transition-property: all;
            transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
            transition-duration: 150ms;
            content: ''
}

        label.s8-input-toggle:after {
            margin-left: 2px;
            margin-right: 2px;
            background-color: rgba(255, 255, 255, 1)
}

        label.s8-input-toggle.s8-md:before {
            height: 1rem;
            width: 1.5rem;
            border-radius: 0.5rem
}

        label.s8-input-toggle.s8-md:after {
            height: 0.75rem;
            width: 0.75rem;
            border-radius: 0.5rem
}

        label.s8-input-toggle.s8-md.s8-left {
            padding-left: 2rem !important
}

        label.s8-input-toggle.s8-md.s8-right {
            padding-right: 2rem !important
}

        label.s8-input-toggle.s8-md.s8-left:before, label.s8-input-toggle.s8-md.s8-left:after {
            left: 0px
}

        label.s8-input-toggle.s8-md.s8-right:before, label.s8-input-toggle.s8-md.s8-right:after {
            right: 0px
}

        label.s8-input-toggle.s8-lg:before {
            height: 1.25rem;
            width: 2rem;
            border-radius: 0.75rem
}

        label.s8-input-toggle.s8-lg:after {
            height: 1rem;
            width: 1rem;
            border-radius: 0.5rem
}

        label.s8-input-toggle.s8-lg.s8-left {
            padding-left: 42px !important
}

        label.s8-input-toggle.s8-lg.s8-right {
            padding-right: 42px !important
}

        label.s8-input-toggle.s8-lg.s8-left:before, label.s8-input-toggle.s8-lg.s8-left:after {
            left: 0px
}

        label.s8-input-toggle.s8-lg.s8-right:before, label.s8-input-toggle.s8-lg.s8-right:after {
            right: 0px
}

    input {
            display: none
}

    input:invalid + label {
            color: rgba(239, 35, 59, 1)
}

    input:disabled + label {
            cursor: not-allowed;
            color: rgba(193, 192, 189, 1)
}

    input:disabled + label:before {
            background-color: rgba(231, 231, 230, 1) !important
}

    input:disabled + label:after {
            background-color: rgba(248, 248, 248, 1) !important
}

    input:checked + label.s8-md.s8-left:after {
            left: 0.5rem
}

    input:checked + label.s8-md.s8-right:after {
            right: 0.5rem
}

    input:checked + label.s8-lg.s8-left:after {
            left: 0.75rem
}

    input:checked + label.s8-lg.s8-right:after {
            right: 0.75rem
}

    input:not(:disabled):not(:checked) + label:before {
            background-color: rgba(212, 211, 209, 1)
}

    input:not(:disabled):checked + label.s8-dark:before {
            background-color: rgba(39, 39, 17, 1)
}

    input:not(:disabled):checked + label.s8-primary:before {
            background-color: rgba(45, 96, 67, 1)
}

    input:not(:disabled):checked + label.s8-secondary:before {
            background-color: rgba(193, 122, 103, 1)
}

    input:not(:disabled):checked + label.s8-tertiary:before {
            background-color: rgba(52, 159, 173, 1)
}

    input:not(:disabled):checked + label.s8-quaternary:before {
            background-color: rgba(102, 83, 162, 1)
}

    input:not(:disabled):checked + label.s8-danger:before {
            background-color: rgba(219, 18, 42, 1)
}

    input:not(:disabled):not(:checked) + label:hover.s8-dark:before {
            background-color: rgba(151, 150, 145, 1)
}

    input:not(:disabled):not(:checked) + label:hover.s8-primary:before {
            background-color: rgba(68, 131, 95, 1)
}

    input:not(:disabled):not(:checked) + label:hover.s8-secondary:before {
            background-color: rgba(230, 152, 131, 1)
}

    input:not(:disabled):not(:checked) + label:hover.s8-tertiary:before {
            background-color: rgba(82, 189, 203, 1)
}

    input:not(:disabled):not(:checked) + label:hover.s8-quaternary:before {
            background-color: rgba(136, 121, 185, 1)
}

    input:not(:disabled):not(:checked) + label:hover.s8-danger:before {
            background-color: rgba(239, 35, 59, 1)
}</style>